import { navigateToUrl } from '../actions/navigation';
import { APP_CLOSED } from '../modules/app/actionTypes';

export function closeMiddleware(close: $TSFixMe) {
    return (store: $TSFixMe) => (next: $TSFixMe) => (action: $TSFixMe) => {
        if (action.type === APP_CLOSED) {
            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
            if (action.payload?.propertyUrl) {
                store.dispatch(navigateToUrl(action.payload?.propertyUrl));
            } else {
                close();
            }
        }

        return next(action);
    };
}
